var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fast"}},[(_vm.isDisplayed)?_c('div',{staticClass:"edition-modal",class:_vm.elClasses,style:(_vm.editionModalStyle)},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }